const isDev = import.meta.env.DEV

const logger = {
  debug(...args: unknown[]) {
    if (isDev) {
      console.log('[DEBUG]', ...args)
    }
  },

  info(...args: unknown[]) {
    if (isDev) {
      console.log('[INFO]', ...args)
    }
  },

  warn(...args: unknown[]) {
    if (isDev) {
      console.warn('[WARN]', ...args)
    }
  },

  error(...args: unknown[]) {
    console.error('[ERROR]', ...args)
  }
}

export default logger
